<script setup lang="ts">
import { ref, computed } from "vue";
import IconDown from "@/assets/icons/arrow-down.svg?component";

const props = defineProps<{
  options: Array<{ value: string; label: string }>;
  value?: string | null;
  placeholder: string;
}>();
const emit = defineEmits<{ "update:value": [string] }>();

const active = ref(false);
const label = computed(
  () => props.options.find((item) => item.value == props.value)?.label
);

function update(value: string) {
  emit("update:value", value);
  active.value = false;
}
</script>
<template>
  <div
    class="ui-select u-row"
    v-click-away="() => (active = false)"
    :class="{ active }"
  >
    <button type="button" class="value u-row" @click="active = !active">
      <span class="label" :class="{ 'cl-black-40': !props.value }">{{
        label ?? placeholder
      }}</span>
      <IconDown />
    </button>
    <div v-show="active" class="options">
      <button
        type="button"
        class="option u-cut u-row"
        :class="{ selected: option.value == props.value }"
        @click="update(option.value)"
        v-for="option in props.options"
        :key="option.value"
      >
        {{ option.label }}
      </button>
    </div>
  </div>
</template>
<style>
.ui-select {
  position: relative;
}

/* value */

.ui-select .value {
  flex: 1;
  border: 1px solid var(--cl-black-20);
  border-radius: 2px;
  justify-content: space-between;
  padding: 10px 12px;
}
.ui-select .value svg {
  width: 18px;
  height: 18px;
}

/* options */

.ui-select .options {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: var(--cl-white);
  border: 1px solid var(--cl-black-20);
  border-radius: 2px;
  border-top: none;
  overflow: hidden;
  z-index: 1;
}
.ui-select .value .label {
  overflow: hidden;
}
.ui-select .options .option {
  flex: 1;
  width: 100%;
  padding: 8px 12px;
  border-top: 1px solid var(--cl-black-20);
}
.ui-select .options .option:hover {
  background-color: var(--cl-powder-green);
}
.ui-select .options .option:first-child {
  border-top: none;
}

/* active state */

.ui-select.active .value {
  border-radius: 2px 2px 0 0;
  border-color: var(--cl-orange);
}
.ui-select.active .value svg {
  color: var(--cl-orange);
}
.ui-select.active .options {
  border-radius: 0 0 2px 2px;
}
.ui-select.active .options .selected {
  color: var(--cl-orange);
  font-weight: 700;
}
</style>
